import { Component, OnInit, Input }  from '@angular/core';
import { FormGroup }                 from '@angular/forms';
import { ViewChild }                 from '@angular/core';
import { ModalDirective }            from 'ng2-bootstrap/modal';
import { DynamicFormService }        from '../../dynamic-form.service';

@Component({
  selector: 'ing-edit-modal',
  templateUrl: './edit-modal.component.html',
  styleUrls: ['./edit-modal.component.scss'],
  providers: [DynamicFormService]
})
export class EditModalComponent implements OnInit {
  @ViewChild('formModal') formModal: ModalDirective;

  @Input('modal-size') modalSize: string = 'modal-lg';

  formTitle: string;
  headerClass: string;
  acceptBtnClass: string;
  formName: string;
  inputs: any;
  form: FormGroup;

  resolve: any;
  reject: any;

  constructor(
    protected dfs: DynamicFormService
  ) { }

  ngOnInit() {
    this.form     = new FormGroup({});
    this.inputs   = [];
    this.formName = 'form';
  }

  closeFormModal() {
    this.formModal.hide();
    this.reject('Cancelado por el usuario');
  }

  onSubmit($event) {
    this.formModal.hide();
    this.resolve(this.form.value);
  }

  show(options: any) {
    this.formTitle      = options.formTitle;
    this.headerClass    = options.headerClass;
    this.acceptBtnClass = options.acceptBtnClass;
    this.inputs         = options.inputs;
    this.form           = this.dfs.toGroup(this.inputs);

    return new Promise((resolve, reject) => {
      this.formModal.show();

      this.resolve = resolve;
      this.reject  = reject;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/edit-modal/edit-modal.component.ts